module.exports = __webpack_public_path__ + "img/Dantam Makeover 14.6269631e.jpg";